/**
 * Shared social timestamp formatter.
 *
 * Keep relative-time presentation in one place so notifications,
 * comments, and feed previews all speak the same language.
 */
export default function formatRelativeTime(value, now = Date.now()) {
  if (!value) return "";

  const timestamp = new Date(value).getTime();

  if (!Number.isFinite(timestamp)) return "";

  const diffMs = Math.max(0, now - timestamp);
  const seconds = Math.floor(diffMs / 1000);

  if (seconds < 10) return "Just now";
  if (seconds < 60) return `${seconds}s ago`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;

  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w ago`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;

  const years = Math.floor(days / 365);
  return `${years}y ago`;
}
